import React from "react";
import { useDispatch } from "react-redux";
import { IFormFieldStyle } from "shared/types";

import { useUnitType } from "shared/utils";

import { UnitConverter as Component } from "../components/UnitConverter";
import { setUnitType } from "../state";

interface UnitConverterProps {
  style?: IFormFieldStyle;
}

export const UnitConverter: React.FC<UnitConverterProps> = props => {
  const dispatch = useDispatch();
  const { unitType } = useUnitType();

  return (
    <Component
      currentUnitType={unitType}
      setUnitType={type => dispatch(setUnitType(type))}
      {...props}
    />
  );
};
